<template>
  <div>
    <div v-show="isNotEndless" class="container">
      <div class="item-ymd">
        <Calendar :name="nameYmd" :default="defaultYmd" size="120" :option="option"/>
      </div>
      <div class="item">
        <SelectForm :name="nameH" :data="hList" :default="h" size="100"/>
      </div>
      <div class="item">
        <SelectForm :name="nameI" :data="iList" :default="i" size="100"/>
      </div>
      <div v-if="option.form ==='Ymd-Hi-END'" @click="setEndless" class="endless-button">無期限</div>
    </div>
    <div v-show="!isNotEndless" class="endless-container">
      無期限<span class="select-date" @click="resetEndless">日時指定</span>
    </div>
  </div>
</template>

<script>
import SelectForm from '@/components/form/SelectForm';
import Calendar from '@/components/form/Calendar';

export default {
  props: ['name', 'default', 'option'],
  components: {
    SelectForm,
    Calendar,
  },
  data () {
    return {
      nameYmd: '',
      nameH: '',
      nameI: '',
      hList: [],
      iList: [],
      h: 10,
      i: 0,
      defaultYmd: '',
      value: null
    };
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    formValuesUpdated: function () {
      this.formUpdate();
    }
  },
  computed: {
    formValuesUpdated: function () {
      return this.$store.getters['formValues/updated'];
    },
    isNotEndless: function (){

      if(typeof this.option === 'undefined'){
        return true;
      }

      if(typeof this.option.form === 'undefined'){
        return true;
      }

      if(this.option.form !== 'Ymd-Hi-END'){
        return true;
      }

      let time = Date.parse(this.value);

      if(isNaN(time)){
        return true;
      }

      let endless = Date.parse('2035-12-31 00:00:00');

      if(time >= endless){
        return false;
      }

      return true;
    }
  },
  created: function () {

    this.initialize();

  },
  methods: {
    initialize: function () {

      let time = null;
      let date = null;

      if (this.default) {
        time = Date.parse(this.default);
        console.log('time', time);

        date = new Date(time);
      } else {
        date = new Date();
      }

      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();

      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }

      this.defaultYmd = y + '-' + m + '-' + d;

      if (this.default) {
        this.h = date.getHours();
        this.i = date.getMinutes();
      }

      // --------

      this.nameYmd = 'DF:' + this.name + '@Ymd';
      this.nameH = 'DF:' + this.name + '@H';
      this.nameI = 'DF:' + this.name + '@I';

      for (let i = 0; i <= 23; i++) {
        this.hList[i] = {label: i + '時', value: i};
      }

      for (let i = 0; i <= 59; i++) {
        this.iList[i] = {label: i + '分', value: i};
      }

      let ymdhis = this.defaultYmd + ' ' + this.h + ':' + this.i + ':00';
      console.log('ymdhis', ymdhis);

      let value = {key: this.name, value: ymdhis};

      this.$store.dispatch('formValues/setFormData', value).then();

      this.value = ymdhis;
    },
    formUpdate: function () {
      console.log('formUpdate', this.formValuesUpdated);

      let prefix = 'DF:' + this.name;

      if (this.formValuesUpdated.key.startsWith(prefix)) {
        console.log('true');

        let values = this.$store.getters['formValues/formData'];

        console.log(values[this.nameYmd]);
        console.log(values[this.nameH]);
        console.log(values[this.nameI]);

        let h = values[this.nameH];
        let i = values[this.nameI];

        if (h < 10) {
          h = '0' + h;
        }
        if (i < 10) {
          i = '0' + i;
        }

        let ymdhis = values[this.nameYmd] + ' ' + h + ':' + i + ':00';
        console.log('ymdhis', ymdhis);

        this.value = ymdhis;

        let value = {key: this.name, value: ymdhis};

        this.$store.dispatch('formValues/setFormData', value).then();

      }

    },
    setEndless: function () {
      console.log('setEndless');
      this.defaultYmd = '2035-12-31';
      this.h = 23;
      this.i = 59;
    },
    resetEndless: function () {
      console.log('resetEndless');

      let date = new Date();

      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();

      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }

      this.defaultYmd = y + '-' + m + '-' + d;
      this.h = 0;
      this.i = 0;

    }
  }

};
</script>

<style lang="scss" scoped>

  .container {
    display: flex;
    align-items: center;

    .item-ymd {
      margin-right: 15px;
    }

    .item {
      margin-right: 5px;
    }
  }

  .select-date,
  .endless-button {
    background: #aaa;
    font-size: 14px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }
    &:active {
      opacity: .9;
    }
  }

  .select-date{
    margin-left: 15px;
    display: inline-block;
  }

  .endless-container{
    font-size: 14px;
  }

</style>
